module.exports = __webpack_public_path__ + "assets/img/banner2024.fb4f485.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner2024.jpg
// module id = 582
// module chunks = 1